import * as React from "react"
import styled from "styled-components"
import parse from "html-react-parser"

import Layout from "../components/layout"
import Seo from "../components/seo"
import Hero from "../components/sections/heros/meetDrScheiner";

const ContentWrapper = styled.section`
  padding: 0 2rem;
`;

const ContentInner = styled.div`
  margin: 0 auto;
  padding: 2rem 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-wrap: pretty;
  font-weight: 500;

  h2, h3, h4, h5, h6 {
    font-weight: 800;
    margin: 1.5rem 0 1rem;
    line-height: 1.2;
    color: var(--color-text);
  }

  h2 {
    font-size: 2.5rem;
  }
  h3 {
    font-size: 2rem;
  }
  h4 {
    font-size: 1.75rem;
  }
  h5 {
    font-size: 1.5rem;
  }
  h6 {
    font-size: 1.25rem;
  }

  > * {
    max-width: 800px;
    width: 100%;
    font-size: 1.25rem;
    line-height: 1.5;

    &.alignwide {
      max-width: 1200px;
    }

    &.alignfull {
      max-width: calc(100% + 4rem);
      margin-left: -2rem;
      margin-right: -2rem;
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }

  .wp-block-media-text {
    display: flex;

    .wp-block-media-text__media {
      min-width: 33%;
    }
  }

  .wp-block-embed {
    &:last-of-type {
      margin-bottom: 0;
    }

    iframe {
      width: 100%;
      aspect-ratio: 16 / 9;
      height: auto;
      margin-bottom: 0;
    }
  }
`

const AwardsHeroTemplate = ({data: {page, hero}}) => {
  const slug = page.uri.replace("/", "")

  return (
    <Layout pageID={page.databaseId} slug={slug}>
      <Seo title={page.seo.title} description={page.seo.metaDesc} seo={page.seo} />
      <style
        dangerouslySetInnerHTML={
          {
            __html: `
              .page-header:not(.sticky){
                box-shadow: none;
              }
              .page-header:not(.sticky),
              .page-header:not(.sticky) #header-menu-toggle {
                background-color: transparent;
              }

              @media (min-width: 1204px) {
                .page-header:not(.sticky) *:not(#header-menu-explore, #header-menu-explore-toggle, #search-toggle) {
                  background-color: transparent;
                }
              }
            `
          }
        }
      />
      <Hero data={ { hero } } />
      <ContentWrapper>
        <ContentInner>
          {parse(page.content)}
        </ContentInner>
      </ContentWrapper>
    </Layout>
  )
}

export default AwardsHeroTemplate
